var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-page" },
    [
      _c("div", { staticClass: "page-toolbar" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { primary: "" },
                on: {
                  click: function ($event) {
                    return _vm.$feature.beforeCreateTableReport(
                      _vm.showAddWidgetModal
                    )
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("tables.addWidget")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                staticClass: "ai-suggest-button",
                on: {
                  click: function ($event) {
                    return _vm.$feature.beforeCreateTableReport(_vm.showWizard)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "copilot-icon",
                  attrs: { src: "/static/img/copilot.png" },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("tables.createDashboardSupsisAssistant")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout-container" }, [
        _c(
          "div",
          { staticClass: "grid-stack" },
          _vm._l(_vm.layout, function (item) {
            return _c(
              "div",
              {
                key: item.i,
                staticClass: "grid-stack-item",
                attrs: {
                  "gs-x": item.x,
                  "gs-y": item.y,
                  "gs-w": item.w,
                  "gs-h": item.h,
                  "gs-id": item.i,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "grid-stack-item-content" },
                  [
                    _vm.isValidWidget(item.i)
                      ? _c(
                          _vm.getWidgetComponent(
                            _vm.getWidgetById(item.i).type
                          ),
                          {
                            tag: "component",
                            attrs: {
                              widget: _vm.getWidgetById(item.i),
                              table: _vm.table,
                              "upstream-filters": _vm.upstreamFilters,
                            },
                            on: {
                              "widget-updated": _vm.handleWidgetUpdated,
                              "widget-duplicated": _vm.handleWidgetDuplicated,
                              delete: _vm.handleDeleteWidget,
                            },
                          }
                        )
                      : _c("div", { staticClass: "invalid-widget" }, [
                          _vm._v(_vm._s(_vm.$t("tables.widgetLoadError"))),
                        ]),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        !_vm.layout.length
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c(
                  "a-empty",
                  { attrs: { description: _vm.$t("tables.noWidgets") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.$feature.beforeCreateTableReport(
                              _vm.showAddWidgetModal
                            )
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("tables.addWidget")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("WidgetCenter", {
        attrs: { visible: _vm.addWidgetModalVisible },
        on: {
          close: _vm.closeAddWidgetModal,
          "widget-type-selected": _vm.selectWidgetType,
        },
      }),
      _vm._v(" "),
      _vm.showWidgetAiWizard
        ? _c("WidgetAiWizard", {
            attrs: { table: _vm.table, page: _vm.page },
            on: {
              "widget-added": _vm.handleWidgetAdded,
              close: function ($event) {
                _vm.showWidgetAiWizard = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }